import { FormType } from '../../../form-types';
import { ZaludQuestionFieldAnswers } from '../questions';

const zaludStiIntake: FormType<ZaludQuestionFieldAnswers> = {
  name: 'STI Treatment Intake',
  questions: [
    {
      key: 'zaludSti_recentTest',
      next: {
        condition: { 'zaludSti_recentTest.yes': true },
        key: 'zaludSti_upload',
        els: 'zaludSti_disqualify'
      }
    },
    'zaludSti_upload',
    {
      key: 'zalud_general_sexAssignedAtBirth',
      next: {
        condition: { 'zalud_general_sexAssignedAtBirth.female': true },
        key: 'zaludSti_intake_symptoms_q1a',
        els: 'zaludSti_intake_symptoms_q1b'
      }
    },
    {
      key: 'zaludSti_intake_symptoms_q1a',
      next: {
        condition: { 'zaludSti_intake_symptoms_q1a.none': true },

        key: 'zaludSti_intake_current_situation',
        els: 'zalud_general_ineligible'
      }
    },
    {
      key: 'zaludSti_intake_symptoms_q1b',
      next: {
        condition: {
          'zaludSti_intake_symptoms_q1b.none': true
        },
        key: 'zaludSti_intake_current_situation',
        els: 'zalud_general_ineligible'
      }
    },
    {
      key: 'zaludSti_intake_current_situation',
      next: {
        condition: {
          'zaludSti_intake_current_situation.none': true
        },
        key: 'zaludSti_intake_recent_treatment',
        els: 'zalud_general_ineligible'
      }
    },
    {
      key: 'zaludSti_intake_recent_treatment',
      next: {
        condition: { 'zaludSti_intake_recent_treatment.yes': true },
        key: 'zalud_general_ineligible',
        els: 'zaludSti_intake_current_symptoms'
      }
    },
    'zaludSti_intake_current_symptoms',
    {
      key: 'zaludSti_intake_consent',
      next: {
        condition: { 'zaludSti_intake_consent.proceed': true },
        key: 'zalud_general_complete',
        els: 'zalud_general_ineligible'
      }
    },
    'zalud_general_complete',
    'zaludSti_disqualify',
    'zalud_general_ineligible'
  ]
};
export default zaludStiIntake;
